import { IGameState } from '../../Game/IGameState';

export function setSoundVolume(state: IGameState, volume: number): IGameState {
    return {
        ...state,
        playerState: {
            ...state.playerState,
            volumeSFX: volume,
        },
    };
}
